import React from 'react';
import { CV_LABELS } from '../../utils/cvLabels';

type Variant = 'pill' | 'plain' | 'underline' | 'bar';

interface SectionHeadingProps {
    title: string;
    /** Section déjà commencée sur une page précédente */
    isContinuation?: boolean;
    primaryColor?: string;
    variant?: Variant;
    className?: string;
    textClassName?: string;
}

/**
 * Titre de section unique dans le flux.
 * En continuation de page : mention discrète « … — suite » (pas un nouveau gros bloc).
 */
const SectionHeading: React.FC<SectionHeadingProps> = ({
    title,
    isContinuation = false,
    primaryColor = '#0f172a',
    variant = 'pill',
    className = '',
    textClassName = '',
}) => {
    if (isContinuation) {
        return (
            <p
                className={`cv-fs-heading text-[10px] font-bold uppercase tracking-[0.2em] mb-2 opacity-45 ${className}`}
                style={{ color: primaryColor }}
            >
                {title} — {CV_LABELS.suite}
            </p>
        );
    }

    if (variant === 'pill') {
        return (
            <div
                className={`cv-fs-heading inline-block text-white px-6 py-2 rounded-r-full mb-3 ${className}`}
                style={{ backgroundColor: primaryColor }}
            >
                <h2 className={`text-sm font-black uppercase tracking-wider ${textClassName}`}>{title}</h2>
            </div>
        );
    }

    if (variant === 'underline') {
        return (
            <h2
                className={`cv-fs-heading text-sm font-black uppercase tracking-wider mb-3 pb-1 border-b-2 ${className} ${textClassName}`}
                style={{ borderColor: primaryColor, color: primaryColor }}
            >
                {title}
            </h2>
        );
    }

    if (variant === 'bar') {
        return (
            <div className={`cv-fs-heading flex items-center gap-2 mb-3 ${className}`}>
                <div className="w-1.5 h-5 rounded-full" style={{ backgroundColor: primaryColor }} />
                <h2 className={`text-sm font-black uppercase tracking-wider ${textClassName}`} style={{ color: primaryColor }}>
                    {title}
                </h2>
            </div>
        );
    }

    return (
        <h2 className={`cv-fs-heading text-sm font-black uppercase tracking-wider mb-3 ${className} ${textClassName}`} style={{ color: primaryColor }}>
            {title}
        </h2>
    );
};

export default SectionHeading;
